import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';

function normalizeMath(text) {
  // Convert \( ... \) and \[ ... \] to $ ... $ / $$ ... $$ so remark-math picks them up.
  return text
    .replace(/\\\[([\s\S]+?)\\\]/g, (_, expr) => `$$${expr}$$`)
    .replace(/\\\(([\s\S]+?)\\\)/g, (_, expr) => `$${expr}$`);
}

const blockComponents = {
  p: ({ children }) => (
    <span className="block leading-relaxed [&+span]:mt-2">{children}</span>
  ),
  ul: ({ children }) => (
    <ul className="list-disc pl-5 my-2 leading-relaxed space-y-1">
      {children}
    </ul>
  ),
  ol: ({ children }) => (
    <ol className="list-decimal pl-5 my-2 leading-relaxed space-y-1">
      {children}
    </ol>
  ),
  li: ({ children }) => <li className="leading-relaxed">{children}</li>,
  code: ({ inline, children, ...props }) =>
    inline ? (
      <code
        className="px-1 rounded bg-black/5 font-mono text-[0.9em]"
        {...props}
      >
        {children}
      </code>
    ) : (
      <code className="font-mono text-[0.9em]" {...props}>
        {children}
      </code>
    ),
  pre: ({ children }) => (
    <pre className="p-2 rounded bg-black/5 overflow-x-auto my-2 text-[0.9em]">
      {children}
    </pre>
  ),
  a: ({ children, ...props }) => (
    <a
      className="text-primary underline"
      target="_blank"
      rel="noreferrer"
      {...props}
    >
      {children}
    </a>
  ),
};

const MarkdownRenderer = ({ text }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, remarkMath]}
      rehypePlugins={[rehypeKatex]}
      components={blockComponents}
    >
      {normalizeMath(text)}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
